const key = Symbol('MenuKey');

export default key;
